module.exports = __webpack_public_path__ + "img/aman.c9af0524.svg";